import { createTheme, type CustomFlowbiteTheme } from 'flowbite-react';
import {
  accordionTheme,
  alertTheme,
  avatarTheme,
  badgeTheme,
  breadcrumbTheme,
  buttonTheme,
  cardTheme,
  carouselTheme,
  checkboxTheme,
  clipboardTheme,
  darkThemeToggleTheme,
  drawerTheme,
  dropdownTheme,
  fileInputTheme,
  floatingLabelTheme,
  footerTheme,
  listGroupTheme,
  listTheme,
  megaMenuTheme,
  modalTheme,
  navbarTheme,
  paginationTheme,
  progressTheme,
  radioTheme,
  ratingTheme,
  selectTheme,
  sidebarTheme,
  spinnerTheme,
  tableTheme,
  tabsTheme,
  textareaTheme,
  textInputTheme,
  timelineTheme,
  toastTheme,
  toggleSwitchTheme,
  tooltipTheme,
} from './theme-files';

export const customTheme: CustomFlowbiteTheme = createTheme({
  accordion: accordionTheme,
  alert: alertTheme,
  avatar: avatarTheme,
  badge: badgeTheme,
  breadcrumb: breadcrumbTheme,
  button: buttonTheme,
  card: cardTheme,
  carousel: carouselTheme,
  checkbox: checkboxTheme,
  clipboard: clipboardTheme,
  darkThemeToggle: darkThemeToggleTheme,
  drawer: drawerTheme,
  dropdown: dropdownTheme,
  fileInput: fileInputTheme,
  floatingLabel: floatingLabelTheme,
  footer: footerTheme,
  list: listTheme,
  listGroup: listGroupTheme,
  megaMenu: megaMenuTheme,
  modal: modalTheme,
  navbar: navbarTheme,
  pagination: paginationTheme,
  progress: progressTheme,
  radio: radioTheme,
  rating: ratingTheme,
  select: selectTheme,
  sidebar: sidebarTheme,
  spinner: spinnerTheme,
  table: tableTheme,
  tabs: tabsTheme,
  textarea: textareaTheme,
  textInput: textInputTheme,
  timeline: timelineTheme,
  toast: toastTheme,
  toggleSwitch: toggleSwitchTheme,
  tooltip: tooltipTheme,
});
